module.exports = __webpack_public_path__ + "static/img/ArticlePresse002.45470d6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ArticlePresse002.jpg
// module id = uNAI
// module chunks = 1